// extracted by mini-css-extract-plugin
export default {"wrapper":"raa-z","message":"saa-z","image":"taa-z"};